'use es6';

/* eslint-disable @typescript-eslint/no-loop-func */
export function getNodeChildren(nodes, id, onlyOpenChildren = true) {
  const directChildren = nodes.filter(node => node.parentId === id);
  return directChildren.flatMap(child => {
    var _child$context;
    return [...(!onlyOpenChildren || (_child$context = child.context) !== null && _child$context !== void 0 && _child$context.open ? [child] : []), ...getNodeChildren(nodes, child.id, onlyOpenChildren)];
  });
}
export function getNodeAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find(node => node.id === id)) === null || _nodes$find === void 0 ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find(node => node.id === currentParentId);
    currentParentId = currentNode === null || currentNode === void 0 ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}